/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import AuthenticationContext from "../../Store/Authentication-Context";
import { Card } from "react-bootstrap";
import ActionButtons from "../JobControl/ActionButton";
import { AppContext } from "../MainComponents/AppContext";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import { AgGridReact } from 'ag-grid-react';
import Axios from "axios";
const Step3 = (props) => {
    const urlParams = new URLSearchParams(window.location.search);
    const { setAuthContext } = useContext(AuthenticationContext);
    const [appContext] = useContext(AppContext);
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState("");
    const [selectedRow, setSelectedRow] = useState([]);
    const columnDefs = [
        {
            headerName: 'Slot',
            field: 'description',
            sortable: true,
            filter: true,
            flex:1
        },
        {
            headerName: 'Times',
            valueGetter: (params) => `${params.data.fromTime} - ${params.data.toTime}`,
            sortable: true,
            filter: true,
            flex: 1
        },
        {
            headerName: 'Selection',
            cellRenderer: (params) => {
                return (
                    <input
                        type="radio"
                        checked={selectedRow && selectedRow.scheduleID === params.data.scheduleID}
                        onChange={() => handleSelectionChange(params.data)}
                    />
                );
            },
            sortable: false,
            filter: false,
            flex: 1
        }
    ];

    const handleSelectionChange = (row) => {
        if (selectedRow && selectedRow.scheduleID === row.scheduleID) {
            // Unselect if the same row is clicked
            setSelectedRow(null);
        } else {
            // Select the new row
            setSelectedRow(row);
        }
    };
    const validate = async () => {

        if (selectedRow && selectedRow.scheduleID !==0) {
            setError("");
            await createOrEditEntraJob();
            props.closePopupModal();
        }
        else {
            setError("Please select any one item");
        }
    };
    function addTimeToCurrentUTC(time) {
        let currentUtcTime = new Date();

        function timeToSeconds(time) {
            const [hours, minutes, seconds] = time.split(":").map(Number);
            return hours * 3600 + minutes * 60 + seconds;
        }

        const totalSeconds = timeToSeconds(time);
        currentUtcTime.setUTCSeconds(currentUtcTime.getUTCSeconds() + totalSeconds);

        function formatDateToString(date) {
            const year = date.getUTCFullYear();
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const day = String(date.getUTCDate()).padStart(2, '0');
            const hours = String(date.getUTCHours()).padStart(2, '0');
            const minutes = String(date.getUTCMinutes()).padStart(2, '0');
            const seconds = String(date.getUTCSeconds()).padStart(2, '0');
            const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');

            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
        }

        return formatDateToString(currentUtcTime);
    }
    async function createOrEditEntraJob() {
        var tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
        if (appContext.entraJob.isEditJob) {
            let payload = {
                Method: "PUT",
                ServiceGroupID: appContext.entraJob.selectedItems[0],
                Name: appContext.entraJob.name,
                Description: appContext.entraJob.description,
                TenantID: sessionStorage.getItem('ManageTenantDomain'),
                Attempt: 0,
                Status: "Scheduled",
                LastMessage: "",
                NextRun: addTimeToCurrentUTC(rowData.find(s => s.scheduleID === selectedRow.scheduleID).fromTime),
                Active: true,
                ScheduleID: selectedRow.scheduleID,
                JobID: appContext.entraJob.jobID
            }
            await Axios.put(API_ROUTE + Routes.UPSERT_GUARDIAN_JOB(orgId) , payload, config)
                .then((response) => {
                    //let result = JSON.parse(response.data);
                })
                .catch((reason) => {
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                    return reason;
                });
        }
        else {
            for (const [, selectedItem] of appContext.entraJob.selectedItems.entries()) {
                //console.log(index + ': ' + selectedItem);
                let payload = {
                    Method: "POST",
                    ServiceGroupID: selectedItem,
                    Name: appContext.entraJob.name,
                    Description: appContext.entraJob.description,
                    TenantID: sessionStorage.getItem('ManageTenantDomain'),
                    Attempt: 0,
                    Status: "Scheduled",
                    LastMessage: "",
                    NextRun: addTimeToCurrentUTC(rowData.find(s => s.scheduleID === selectedRow.scheduleID).fromTime),
                    Active: true,
                    ScheduleID: selectedRow.scheduleID,
                }
                try {
                    await Axios.post(API_ROUTE + Routes.UPSERT_GUARDIAN_JOB(orgId), payload, config);
                } catch (reason) {
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                    console.error(reason);
                }
            }
        }
        
    }
    async function getGaurdianSchedule() {
        var tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        const data = await Axios.get(API_ROUTE + Routes.GET_GUARDIAN_SCHEDULE, config)
            .then((response) => {
                let result = JSON.parse(response.data);
                setRowData(result)
                return result;
            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
                return reason;
            });

        return data;
    }
    useEffect(() => {
        getGaurdianSchedule();
    }, []);
    useEffect(() => {
        setSelectedRow(prev => ({
            ...prev,
            scheduleID: appContext.entraJob.schedule
        }));
    }, [appContext.entraJob]);
    return (
        <Card>
            <Card.Header>
                <span id="TitleLabel" className="SectionTitle">Schedule & Confirm</span>
            </Card.Header>
            <Card.Body>
                <span id="WizardRequiredFieldValidatorEntraSelectItems" className='mb-2' style={{ color: "red", display: 'block', width: '100%', textAlign: 'center' }} >{error}</span>
                <div className="ag-theme-alpine p-1 pt-0" style={{ width: "100%", height: "181px", borderCollapse: "collapse" }} >
                    <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        rowSelection={{ mode: 'multiRow', checkboxes: false, enableClickSelection: true }}
                    />
                </div>
            </Card.Body>
            <Card.Footer>
                <table cellSpacing="5" cellPadding="5" align="right">
                    <tbody>
                        <tr>
                            <td >
                                <ActionButtons {...props} lastStep={validate} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Card.Footer>
        </Card>
    );
}
export default Step3;